export function numberToString(number?: number | null) {
  if (typeof number !== 'number') {
    return;
  }

  return number.toString();
}
